import commons from './commons'
import actions from "./actions";

export default {
  commons,
  actions
}
